import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { getSessionId, getLeadId } from "@/utils/sessionTracker";
import { auth } from "@/firebase/firebase";

export interface TrackActivityPayload {
  source:
    | "college_view"
    | "course_view"
    | "global_search"
    | "country_search"
    | "course_finder"
    | "chatbot"
    | "application_start"
    | "application_abandon"
    | "session_start"
    | "session_end";
  input?: Record<string, unknown>;
}

export const trackActivity = createAsyncThunk<
  any,
  TrackActivityPayload,
  { rejectValue: string }
>("activity/trackActivity", async (payload, { rejectWithValue }) => {
  try {
    const leadId = getLeadId();
    const sessionId = getSessionId();
    const userId = auth?.currentUser?.uid;

    const data: any = {
      source: payload.source,
      input: payload.input || {},
      sessionId,
    };

    if (userId) {
      data.userId = userId;
    } else if (leadId) {
      data.leadId = leadId;
    }

    const response = await axiosInstance.post("/students/track/activity", data);
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Failed to track activity.";
    return rejectWithValue(message);
  }
});
